export default {
	name: 'usage',
	path: '/usage',
	redirect: '/usage/desc',
	meta: {
		title: 'usage'
	},
	children: [
		{
			name: 'usage-desc',
			path: 'desc',
			fullPath: '/usage/desc',
			meta: {
				title: '使用帮助'
			},
			component: () =>
				import(/* webpackChunkName: "usage" */ '@/views/usage/desc')
		},
		{
			name: 'usage-details',
			path: 'details',
			fullPath: '/usage/datails',
			meta: {
				title: '帮助详情'
			},
			component: () =>
				import(/* webpackChunkName: "usage" */ '@/views/usage/details')
		}
	]
};
